<template>
  <div>
    <div id="main">
      <el-form
        :model="changePasswordForm"
        :rules="rules"
        label-position="left"
        ref="changePasswordForm"
        label-width="135px"
        class="changePasswordForm"
        hide-required-asterisk
      >
        <el-form-item :label="$t('changePassword.oldPassword')" prop="oldPassword">
          <el-input
            size="registInput"
            type="password"
            v-model="changePasswordForm.oldPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('changePassword.newPassword')" prop="password">
          <el-input
            size="registInput"
            type="password"
            v-model="changePasswordForm.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('changePassword.confirmPassword')"
          prop="confirmPassword"
        >
          <el-input
            size="registInput"
            id="test"
            type="password"
            v-model="changePasswordForm.confirmPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item style="margin-top: 90px">
          <el-button
           
            type="submit"
            @click="submitForm('changePasswordForm')"
            >{{$t('changePassword.confirm')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie"
import qs from "qs";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("changePassword.pleaseEnterPassword")));
      } else if (value.length < 6) {
        callback(new Error(this.$t("changePassword.atLeast6")));
      } else {
        if (this.changePasswordForm.confirmPassword !== "") {
          this.$refs.changePasswordForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("changePassword.pleaseEnterPassword")));
      } else if (value !== this.changePasswordForm.password) {
        callback(new Error(this.$t("changePassword.passwordNotMatch")));
      } else {
        callback();
      }
    };

    return {
      changePasswordForm: {
        oldPassword: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        oldPassword: [
          { required: true, message: this.$t("changePassword.pleaseEnterPassword"), trigger: "blur" },
        ],
        password: [
          { validator: validatePass, trigger: "blur" },
          {
            // pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
            message: this.$t("changePassword.numbers"),
            trigger: "blur",
          },
        ],
        confirmPassword: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //alert("submit!");
          this.changePassword();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changePassword() {
      this.$refs.changePasswordForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let url = "/api/login/changePassword";
          this.$http
            .post(
              url,
              qs.stringify({
                userId: localStorage.getItem("userId"),
                userName:localStorage.getItem("user"),
                oldPassword: this.changePasswordForm.oldPassword,
                password: this.changePasswordForm.confirmPassword,
              })
            )
            .then((response) => {
              this.loading = false;
              this.response = JSON.stringify(response.data);
              if (response.data.code === 200) {
                this.$message({
                  message: response.data.data,
                  type: "success",
                });
                this.$refs["changePasswordForm"].resetFields()
                // localStorage.removeItem('user')
                // localStorage.removeItem('userName')
                // localStorage.removeItem('userLastName')
                // localStorage.removeItem('userFirstName')
                // localStorage.removeItem('userId')
                // localStorage.removeItem('email')
                // localStorage.removeItem('company')
                // localStorage.removeItem('companyId')
                // localStorage.removeItem('networkManage')
                // localStorage.removeItem('lastLoginTimeAsUser')
                // localStorage.removeItem('lastLoginTimeAsCompany')
                // Cookies.remove('access_token')
                // this.$http.get('/api/logout').then(res => {
                //   if (res.data.code === 200) {
                //     // this.$router.push('/login')
                //   }
                // }).catch(e => {
                //   console.log(e)
                // })
              } else if (response.data.message === "旧密码错误") {
                this.$message.error(this.$t("changePassword.oldPasswordError"));
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
              this.$message.error(this.$t("changePassword.anErrorOccurred"));
            });
        }
      });
    },
    // 消息提示
    alertMessage() {
      this.$alert(this.$t("changePassword.newUsersPleaseChangePasswordsFirst"), this.$t("common.tips"), {
        confirmButtonText: this.$t("common.confirm"),
        callback: () => {
          sessionStorage.removeItem('loginFirst')
        }
      })
    }
  },

  created() {
    if (sessionStorage.loginFirst === '0') {
      this.alertMessage()
    }
  },

  destroyed() {
    sessionStorage.removeItem('loginFirst')
  }
};
</script>

<style lang="scss" scoped>
#main {
  /* width: 1195px; */
  width: 668px;
  /* height: 744px; */
  margin: 0 auto;
  border-radius: 0 0 30px 30px;
}
.changePasswordForm {
  width: 468px;
  /* height: 622px; */
  padding-top: 180px;
  position: relative;
  left: -67.5px;
  padding-left: 80px;

}
.el-input {
  width: 333px;
}
>>>.el-form-item__label {
  font-family: "Arial Normal", "Arial";
  color: #333333;
  padding-left: 30px;
}
.el-select-dropdown__item {
  color: #333333;
}

</style>



// WEBPACK FOOTER //
// src/views/Mine/P0901.vue